import * as types from './index';

export const feedbackFilterEventsListAction = (data) => {
    return {
    type: types.FEEDBACK_FILTER_EVENTS_LIST,
    data
    }
};

export const feedbackFilterReviewersListAction = (data) => {
    return {
    type: types.FEEDBACK_FILTER_REVIEWERS_LIST,
    data
    }
};

export const feedbackGetChiefReviewersListAction =(data) =>{ 
    return {
        type: types.CHIEF_REVIEWERS_LIST,
        data
    }
}


